import { Tag } from 'antd';
import { TRUCK_STATUS_COLORS, TRUCK_STATUS_LABELS } from '../policies/truck-status-labels';
import type { TruckStatusHistoryEntry } from '../trucks.api';

/** A truck's status moves, oldest first — evidence from `fleet.events.ts` (gitaumoses4/chukua#19), never a manual edit. */
export function TruckStatusHistory({ entries }: { entries: TruckStatusHistoryEntry[] }) {
  if (entries.length === 0) return null;

  return (
    <ul className="flex flex-col gap-3">
      {entries.map((entry) => (
        <li key={entry.id} className="flex items-center justify-between gap-2 border-b border-line pb-3 last:border-0 last:pb-0">
          <div className="flex items-center gap-2">
            <Tag color={TRUCK_STATUS_COLORS[entry.fromStatus]}>{TRUCK_STATUS_LABELS[entry.fromStatus]}</Tag>
            <span className="text-muted">→</span>
            <Tag color={TRUCK_STATUS_COLORS[entry.toStatus]}>{TRUCK_STATUS_LABELS[entry.toStatus]}</Tag>
          </div>
          <span className="text-xs text-muted">{new Date(entry.occurredAt).toLocaleString()}</span>
        </li>
      ))}
    </ul>
  );
}
